function restoreItem(id, model) {
  if (app.restoringItem == true) {
    return;
  }
  app.tooltipRow && app.tooltipRow.close();
  restoreRequest([id], model);
}

function restoreItems(model) {
  if (app.restoringItem == true) {
    return;
  }
  var ids = getSelectedIds();
  if (ids.length) {
    restoreRequest(ids, model);
  }
  closeMultiselectOptions();
}

function restoreRequest(ids, model) {
  $.ajax({
    url: '/admin/request/restore',
    method: 'post',
    data: {
      ids: ids,
      model: model
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.restoringItem = true;
    },
    success: function (response) {
      app.restoringItem = false;
      if (response && response.success) {
        var selector = getMultiSelectRowsSelector(ids);
        $(selector).fadeOut(500, function () {
          $(this).remove();
          showSelectedItems();
          checkEmptyListMessage();
          success(getMultiSelectSuccessMessage(ids, 'wiederhergestellt'));
        });
        return;
      }
      error();
    },
    error: function () {
      app.restoringItem = false;
      ajaxError();
    }
  });
}
